<template>
  <PopupTemplate @close="closeCuponAmigoActivado()">
    <div>
      <div class="cabecera">¡Enhorabuena!</div>
      <p class="cuponAmigoActivado"></p>
      <p>
        Un amigo tuyo ha utilizado tu cupón y ha conseguido un 10% de descuento
        en su póliza.
      </p>
      <p>En breve dispondrás tú también de tu descuento.</p>
      <p>¡Te mantendremos informado!</p>
    </div>
  </PopupTemplate>
</template>

<script>
/* eslint-disable no-console */
export default {
  props: {
    cuponInic: { type: String, required: true, default: null }
  },

  data() {
    return {
      cupon: this.cuponInic
    };
  },

  created() {
    console.log(this.cuponInic);
  },

  methods: {
    closeCuponAmigoActivado() {
      console.log("close de Popup");
      this.$emit("closeInfoCuponAmigo");
    }
  }
};
</script>

<style lang="scss">
.cuponAmigoActivado {
  width: 15rem;
}

.cabecera {
  font-size: 120%;
  width: 15rem;
  margin-bottom: 1rem;
  color: $colorMMT;
  border-bottom: 2px solid $azulOscuroMMT;
}
</style>
